module.exports = __webpack_public_path__ + "img/newsbg.6489a747.jpg";